import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import { formatDateForTable } from '../../../utils/formatDate';
import BackHandOutlinedIcon from '@mui/icons-material/BackHandOutlined';
import InstallDesktopOutlinedIcon from '@mui/icons-material/InstallDesktopOutlined';
import { statusMatching } from '../utils/statusMatching';
import CachedIcon from '@mui/icons-material/Cached';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import { useDispatch } from 'react-redux';
import {
  downloadImportHistory,
  forceImport,
} from '../../../store/importHistoryReducer';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const tooltioSlotProps = {
  popper: {
    modifiers: [
      {
        name: 'offset',
        options: {
          offset: [0, -7],
        },
      },
    ],
  },
};

export const useImportColumns = (requestForImports, setOpenErrorDialogData) => {
  const dispatch = useDispatch();

  const handleForceImport = (id) => {
    dispatch(forceImport(id)).then(() => {
      requestForImports();
    });
  };
  const handleDownload = (id) => {
    dispatch(downloadImportHistory(id));
  };
  return [
    {
      field: 'type',
      headerName: 'Import type',
      flex: 1,
      minWidth: 100,

      renderCell: ({ value }) => {
        return value === 'manual' ? (
          <Tooltip
            arrow
            title="Manual"
            placement="top"
            slotProps={tooltioSlotProps}
          >
            <BackHandOutlinedIcon />
          </Tooltip>
        ) : (
          <Tooltip
            arrow
            title="Auto"
            placement="top"
            slotProps={tooltioSlotProps}
          >
            <InstallDesktopOutlinedIcon />
          </Tooltip>
        );
      },
    },
    {
      field: 'created_at',
      headerName: 'Import Date',
      flex: 1,
      minWidth: 100,

      renderCell: ({ value }) => {
        const date = formatDateForTable(value, true);

        return (
          <Box>
            <Typography
              sx={{
                fontWeight: 'bold',
              }}
            >
              {date.formattedDate}
            </Typography>
            <Typography>{date.formattedTime}</Typography>
          </Box>
        );
      },
    },
    {
      field: 'user',
      headerName: 'User',
      flex: 1,
    },
    {
      field: 'file_path',
      headerName: 'File type and name',
      flex: 2,
      minWidth: 375,
      valueGetter: ({ value }) => {
        if (value?.includes('/')) {
          const nameArr = value.split('/');
          return nameArr[nameArr.length - 1];
        } else return value;
      },
    },
    {
      field: 'status',
      headerName: 'Import Status',
      flex: 1,
      minWidth: 100,

      renderCell: ({ value }) => {
        const status = statusMatching(value);
        return (
          <Box
            sx={{
              background: status.bg,
              padding: '5px 15px',
              borderRadius: '3px',
              color: status.color,
            }}
          >
            {status.text}
          </Box>
        );
      },
    },

    {
      field: 'Action',
      headerName: 'Actions',
      description: 'This column has a value getter and is not sortable.',
      sortable: false,
      flex: 1,
      renderCell: ({ row }) => {
        const currentStatus = statusMatching(row.status);

        return (
          <>
            <Tooltip
              arrow
              title="Download"
              placement="top"
              slotProps={tooltioSlotProps}
            >
              <IconButton onClick={() => handleDownload(row.id)}>
                <DownloadForOfflineIcon
                  sx={{
                    color: '#DCFCE7',
                    background: '#174A2A',
                    borderRadius: '50%',
                  }}
                />
              </IconButton>
            </Tooltip>
            <Tooltip
              arrow
              title="Force sync"
              placement="top"
              slotProps={tooltioSlotProps}
            >
              <span>
                <IconButton
                  onClick={() => handleForceImport(row.id)}
                  disabled={currentStatus.text === 'Complete'}
                >
                  <CachedIcon />
                </IconButton>
              </span>
            </Tooltip>
            {row.status === 'failed' && (
              <Tooltip
                arrow
                title="Alert details"
                placement="top"
                slotProps={tooltioSlotProps}
              >
                <IconButton
                  onClick={() =>
                    setOpenErrorDialogData({ open: true, errors: row.errors })
                  }
                >
                  <WarningAmberIcon sx={{ color: '#F27D00' }} />
                </IconButton>
              </Tooltip>
            )}
          </>
        );
      },
    },
  ];
};

export default useImportColumns;
